/* ========================================================================
   SF Global Brands — Swiper initializer
   ======================================================================== */
(function () {
  'use strict';

  var initialized = new WeakMap();

  function readBool(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return String(value).toLowerCase() === 'true';
  }

  function readInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function initOne(el) {
    if (!el || initialized.get(el)) return;
    if (typeof window.Swiper !== 'function') return;

    var ds = el.dataset;
    var perMobile = readInt(ds.perViewMobile, 3);
    var perTablet = readInt(ds.perViewTablet, 5);
    var perDesktop = readInt(ds.perViewDesktop, 8);
    var gapMobile = readInt(ds.gapMobile, 12);
    var gapDesktop = readInt(ds.gapDesktop, 20);
    var autoplayEnabled = readBool(ds.autoplay, true);
    var autoplayDelay = readInt(ds.autoplayInterval, 3000);
    var pauseOnHover = readBool(ds.pauseOnHover, true);
    var loop = readBool(ds.loop, true);
    var showDots = readBool(ds.showDots, false);
    var showArrows = readBool(ds.showArrows, true);

    var options = {
      slidesPerView: perMobile,
      spaceBetween: gapMobile,
      watchOverflow: true,
      grabCursor: true,
      speed: 500,
      breakpoints: {
        750: { slidesPerView: perTablet, spaceBetween: gapDesktop },
        990: { slidesPerView: perDesktop, spaceBetween: gapDesktop }
      }
    };

    if (loop) options.loop = true;

    if (autoplayEnabled) {
      options.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover
      };
    }

    if (showArrows) {
      options.navigation = {
        prevEl: el.querySelector('.swiper-button-prev'),
        nextEl: el.querySelector('.swiper-button-next')
      };
    }

    if (showDots) {
      options.pagination = {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      };
    }

    var swiper = new window.Swiper(el, options);
    initialized.set(el, swiper);
    el.swiperInstance = swiper;
  }

  function destroyOne(el) {
    var instance = initialized.get(el);
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy(true, true);
      initialized.delete(el);
      el.swiperInstance = null;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sfgb-swiper]').forEach(initOne);
  }

  if (typeof window.Swiper === 'function') {
    initAll();
  } else {
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (typeof window.Swiper === 'function') {
        clearInterval(poll);
        initAll();
      } else if (tries > 40) {
        clearInterval(poll);
      }
    }, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-sfgb-swiper]');
    if (el) initOne(el);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-sfgb-swiper]');
    if (el) destroyOne(el);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('.sf-global-brands__slide');
    if (!slide) return;
    var el = slide.closest('[data-sfgb-swiper]');
    var instance = el && initialized.get(el);
    if (!instance) return;
    var idx = Array.prototype.indexOf.call(slide.parentElement.children, slide);
    if (typeof instance.slideToLoop === 'function') instance.slideToLoop(idx);
    else if (typeof instance.slideTo === 'function') instance.slideTo(idx);
  });
})();
